import styled from 'styled-components';
import { stripeScroll, pulse } from '@shared/theme/animations';

interface ProgressProps {
  $percent: number;
}

const Track = styled.div`
  width: 100%;
  height: 8px;
  background: ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.radius.pill};
  overflow: hidden;
  position: relative;
`;

const Fill = styled.div<ProgressProps>`
  height: 100%;
  width: ${({ $percent }) => $percent}%;
  border-radius: ${({ theme }) => theme.radius.pill};
  background-color: ${({ theme }) => theme.colors.primary};
  background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.18) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.18) 50%,
    rgba(255, 255, 255, 0.18) 75%,
    transparent 75%,
    transparent
  );
  background-size: 32px 32px;
  animation: ${stripeScroll} 800ms linear infinite;
  transition: width ${({ theme }) => theme.motion.slow} ${({ theme }) => theme.motion.easeOut};
  box-shadow: 0 0 12px ${({ theme }) => theme.colors.primary}55;
`;

/**
 * Construction-tape progress bar — striped fill that scrolls while work is in progress.
 */
export function Progress({ percent }: { percent: number }) {
  return (
    <Track>
      <Fill $percent={Math.max(0, Math.min(100, percent))} />
    </Track>
  );
}

const Dot = styled.span<{ $i: number }>`
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.primary};
  animation: ${pulse} 1100ms ${({ theme }) => theme.motion.easeInOut} infinite;
  animation-delay: ${({ $i }) => `${$i * 140}ms`};
`;

const DotsRow = styled.span`
  display: inline-flex;
  gap: 6px;
  align-items: center;
`;

/** Three pulsing dots — fits inline next to a label like "Обработка". */
export function Loader() {
  return (
    <DotsRow aria-label="Загрузка">
      <Dot $i={0} />
      <Dot $i={1} />
      <Dot $i={2} />
    </DotsRow>
  );
}
